export default __webpack_public_path__ + "static/media/silhouetteParent.b5e1de1f.png";